export default __webpack_public_path__ + "83d7fb67867fc134854c385d177e4436.jpeg";